import React, { useState } from "react";
import { FaBars, FaShoppingCart } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import DashboardDropdown from "../AdminDropdown/DasboardDropdown";
// import LanguageDropdown from "../AdminDropdown/LanguageDropdown";
import axios from "axios";
import { apiKey } from "../../config/config";
import { TfiReload } from "react-icons/tfi";
import { FaTablet } from "react-icons/fa6";
import { languageHelper } from "../../config/helperFunctions";

export default function Navbar({ toggleModal, handleLangChange, general }) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";

  const navigate = useNavigate();

  const handleReload = () => {
    window.location.reload();
  };

  // Requires a password before a cashier can even open the register-details
  // screen (which shows sales totals, VAT, etc.), if the restaurant setting
  // "close_register_password_enabled" is turned on (Restaurant Setting
  // page). Other roles (admin/manager/super-admin) are never gated by this.
  const closeRequiresPassword =
    user?.user?.role === "cashier" &&
    general?.close_register_password_enabled === "yes";

  // "POS" isn't part of the module_access permission list (it's never in
  // any role's stored list, riders included), so this shortcut showed for
  // every logged-in staff member unconditionally -- a rider has no
  // business on the sales terminal at all, so hide it specifically for
  // that role rather than trying to route it through module_access.
  const hasPosAccess = user?.user?.role !== "rider";
  const [showClosePasswordPrompt, setShowClosePasswordPrompt] =
    useState(false);
  const [closePasswordInput, setClosePasswordInput] = useState("");
  const [closePasswordError, setClosePasswordError] = useState("");

  const openShift = () => {
    axios
      .get(`${apiKey}/api/rms/admin/verifyShift`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toggleModal(true);
      })
      .catch((err) => {
        navigate("openRegister");
      });
  };

  const handleShift = () => {
    if (closeRequiresPassword) {
      setClosePasswordInput("");
      setClosePasswordError("");
      setShowClosePasswordPrompt(true);
      return;
    }
    openShift();
  };

  const confirmClosePassword = () => {
    if (closePasswordInput !== general?.close_register_password) {
      setClosePasswordError(
        languageHelper("Incorrect password.") || "Incorrect password."
      );
      return;
    }
    setShowClosePasswordPrompt(false);
    openShift();
  };

  return (
    <>
    <header>
      {/* Navbar */}
      <nav className="relative shadow-lg bg-[#fff] md:flex-row md:flex-nowrap md:justify-start flex items-center py-4 px-2 w-full rounded-md">
        <div className="w-full mx-auto gap-4 items-center flex justify-between md:flex-nowrap flex-wrap md:px-4 px-2">
          {/* Toggle button for sidebar */}
          <button
            className="lg:hidden text-[#6f6b7d] hover:text-d-bg-text"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <FaBars />
          </button>
          {/* Navigation links (hidden on small screens) */}
          <div className="hidden lg:flex gap-4">
            {hasPosAccess && (
              <NavLink to="/POS/main" className="flex gap-1 items-center group">
                <FaTablet className=" fill-[#6f6b7d] group-hover:fill-d-bg-text" />
                <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
                  {languageHelper("pos") || "POS"}
                </span>
              </NavLink>
            )}
            {hasPosAccess && (
              <NavLink
                to="./purchase/addPurchase"
                className="flex gap-1 items-center group"
              >
                <FaShoppingCart className=" fill-[#6f6b7d] group-hover:fill-d-bg-text" />
                <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
                  {languageHelper("add purchase") || "All Purchases"}
                </span>
              </NavLink>
            )}
            {hasPosAccess && (
              <button
                className="flex gap-1 items-center text-[#6f6b7d] uppercase text-sm font-semibold group hover:text-d-bg-text"
                type="button"
                onClick={handleShift}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                    height="16"
                    width="18"
                  >
                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                  </svg>
                </span>
                {languageHelper("shift open close") || "Shift Open/Close"}
              </button>
            )}
          </div>
          <div className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto ">
            <div className="relative flex w-full flex-wrap gap-4 items-stretch">
              {/* <NavLink
                to="watchUser"
                className="flex gap-1 items-center group relative"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                  height="16"
                  width="18"
                >
                  <path d="M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z" />
                </svg>
                <span className="hidden group-hover:block w-32 bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  Watch User Guide
                </span>
              </NavLink> */}

              <NavLink
                to="/"
                target="_blank"
                className="flex gap-1 items-center relative group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                  height="16"
                  width="18"
                >
                  <path d="M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
                </svg>
                <span className="hidden group-hover:block bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  {languageHelper("web") || "Website"}
                </span>
              </NavLink>

              <div className="flex items-center gap-1 bg-white h-8 px-1 border border-d-bg rounded-md">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="14"
                  width="14"
                  viewBox="0 0 512 512"
                  className="fill-d-bg-text shrink-0"
                >
                  <path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.1-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.1 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z" />
                </svg>
                <button
                  type="button"
                  title="English"
                  onClick={() => handleLangChange("text_en")}
                  className={`px-2 h-6 rounded text-xs font-semibold transition-colors ${
                    defaultLang === "text_en"
                      ? "bg-d-bg text-white"
                      : "text-d-bg-text"
                  }`}
                >
                  English
                </button>
                <button
                  type="button"
                  title="العربية"
                  onClick={() => handleLangChange("text_ar")}
                  className={`px-2 h-6 rounded text-xs font-semibold transition-colors ${
                    defaultLang === "text_ar"
                      ? "bg-d-bg text-white"
                      : "text-d-bg-text"
                  }`}
                >
                  عربي
                </button>
              </div>

              <button
                onClick={handleReload}
                className="flex gap-1 items-center relative group"
              >
                <TfiReload className="fill-[#6f6b7d] group-hover:fill-d-bg-text font-semibold" />

                <span className="hidden group-hover:block bg-gray-800 px-1 text-sm text-gray-100 rounded-md absolute left-1/2 -translate-x-1/2 translate-y-full m-4 mx-auto">
                  {languageHelper("reload") || "Reload"}
                </span>
              </button>

              <button to="/" className="flex gap-1 items-center ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] hover:fill-d-bg-text"
                  height="20"
                  width="30"
                >
                  <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
                </svg>
              </button>

              {/* <LanguageDropdown /> */}
              <DashboardDropdown />
            </div>
          </div>
        </div>
      </nav>
      {/* Sidebar (visible on small screens) */}
      <div
        className={`fixed top-0 right-0 h-full z-50 w-64 bg-white shadow-lg transform ${
          sidebarOpen ? "translate-x-0" : "translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        {/* Close button */}
        <div className="flex justify-start p-4">
          <button
            className="text-[#6f6b7d] hover:text-d-bg-text"
            onClick={() => setSidebarOpen(false)} // Close sidebar when clicked
          >
            <FaBars />
          </button>
        </div>

        <div className="flex justify-end p-4">
          <button
            className="text-[#6f6b7d] hover:text-d-bg-text"
            onClick={() => setSidebarOpen(false)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-6 w-6"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav className="flex flex-col gap-4 p-4">
          {hasPosAccess && (
            <NavLink to="/POS/main" className="flex gap-1 items-center group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className=" fill-[#6f6b7d] group-hover:fill-d-bg-text"
                height="16"
                width="18"
              >
                <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z" />
              </svg>
              <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
                {languageHelper("pos") || "POS"}
              </span>
            </NavLink>
          )}
          {hasPosAccess && (
            <NavLink
              to="./purchase/addPurchase"
              className="flex gap-1 items-center group"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                height="16"
                width="18"
              >
                <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
              </svg>
              <span className="text-[#6f6b7d] text-sm group-hover:text-d-bg-text">
                {languageHelper("add purchases") || "All Purchases"}
              </span>
            </NavLink>
          )}
          {hasPosAccess && (
            <button
              className="flex gap-1 items-center text-[#6f6b7d] uppercase text-sm font-semibold group hover:text-d-bg-text"
              type="button"
              onClick={() => {
                handleShift();
                setSidebarOpen(false);
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="fill-[#6f6b7d] group-hover:fill-d-bg-text"
                  height="16"
                  width="18"
                >
                  <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                </svg>
              </span>
              {languageHelper("shift open close") || "Shift Open/Close"}
            </button>
          )}
        </nav>
      </div>
      {/* End Navbar */}
    </header>

    {showClosePasswordPrompt && (
      <div
        className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-50"
        onClick={() => setShowClosePasswordPrompt(false)}
      >
        <div
          className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
          onClick={(e) => e.stopPropagation()}
        >
          <h1 className="text-d-bg-text font-semibold text-xl text-center">
            {languageHelper("Password Required") || "Password Required"}
          </h1>
          <p className="text-center text-gray-700 text-sm">
            {languageHelper("Enter the register password to continue.") ||
              "Enter the register password to continue."}
          </p>
          <input
            type="password"
            autoFocus
            className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white border rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
            placeholder={languageHelper("Password")}
            value={closePasswordInput}
            onChange={(e) => setClosePasswordInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") confirmClosePassword();
            }}
          />
          {closePasswordError && (
            <p className="text-center text-red-500 text-sm">
              {closePasswordError}
            </p>
          )}
          <div className="flex justify-center gap-4">
            <button
              className="bg-slate-700 text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              onClick={() => setShowClosePasswordPrompt(false)}
            >
              {languageHelper("Cancel") || "Cancel"}
            </button>
            <button
              className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              onClick={() => confirmClosePassword()}
            >
              {languageHelper("Confirm") || "Confirm"}
            </button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
